import * as format from 'date-fns/format'
import * as React from 'react'
import { IProgramServiceMembership } from '../../types/membership'
import UserLogo from '../icons/ui/UserLogo'
import Wheelchair from '../icons/ui/Wheelchair'

export interface ITableRowProps {
  item: IProgramServiceMembership
  toggleModal?: (item: IProgramServiceMembership) => void
}

class TableRow extends React.Component<ITableRowProps, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      settingsState: false,
      membershipResponse: {
        responseType: null,
        expirationDate: null,
        recurring: null,
        numberRides: null,
        limitedTime: null
      }
    }
  }

  public toggleModal = () => this.props.toggleModal && this.props.toggleModal(this.props.item)

  public render() {
    const row = this.props.item
    const phoneNumber = row.rider.phones.map(it => `${it.countryCode} ${it.phoneNumber}`).join(`,`)
    const organizationName =
      row.programService && row.programService.organization && row.programService.organization.name
    const programServiceName = row.programService && row.programService.name
    return (
      <div
        className={'Row cursor--pointer flex items-start col-12 h6 font-grey2 my2 px2 border-box'}
        onClick={this.toggleModal}
      >
        <div className='flex items-center col-2'>
          <UserLogo />
          <div className='mx1'>
            <div className='font-dark-grey h5'>
              {row.rider.firstName} {row.rider.lastName}
            </div>
            <div className='font-grey2'>{row.rider.birthDate}</div>
          </div>
        </div>

        <div className='flex items-center col-2 h5 font-dark-grey mt2'>{phoneNumber}</div>

        <div className='flex items-center col-1 mt2'>
          <Wheelchair className='icon--small svg-dark-grey ml2' />
        </div>

        <div className='flex items-center col-2 h5 font-dark-grey mt2'>{organizationName}</div>

        <div className='flex items-center col-1 h5 font-dark-grey mt2'>{programServiceName}</div>

        <div className='mt2 font-dark-grey col-2'>{format(row.requestedAt, 'MM.D.YYYY h.mma')}</div>

        <div className='Status flex items-center col-1 mt1 font-dark-grey'>{row.status}</div>
      </div>
    )
  }
}

export default TableRow



// WEBPACK FOOTER //
// ./src/components/membership-request/TableRow.tsx